module.exports = __webpack_public_path__ + "assets/img/focal-length.d031777a.svg";